export default __webpack_public_path__ + "static/media/c4-removebg-preview.e6bb21bd.png";